export default __webpack_public_path__ + "static/media/city-hall-official-journal-negative.d4bb7af7.svg";